import React from "react";
import LoadingIcon from "../icons/LoadingIcon";
import clsx from "clsx";

const SecondaryButton = ({
  disabled,
  loading,
  type = "submit",
  children,
  startIcon,
  endIcon,
  ...others
}) => {
  // outline outline-1 outline-secondaryBorder
  // !outline-primaryDisabledBorder
  return (
    <button
      disabled={disabled || loading}
      type={type}
      className={clsx(
        "bg-secondary hover:bg-secondaryHover text-primaryText w-full px-4 py-[10px] shadow-sm rounded-lg flex items-center justify-center text-base font-semibold leading-6 text-secondaryText",
        {
          "cursor-progress": loading,
          "cursor-not-allowed !bg-primaryDisabledBg !text-primaryDisabledText":
            disabled,
        }
      )}
      {...others}
    >
      <div className="flex items-center gap-2">
        {loading ? <LoadingIcon type="secondary" /> : startIcon}
        <span>{children}</span>
        {Boolean(endIcon) && endIcon}
      </div>
    </button>
  );
};

export default SecondaryButton;
